import React from 'react';

import {EventReviewFeedback} from 'src/modules/ai';
import {EVENT_SOURCE_FIELD_NAME} from 'src/modules/ai/constants';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';

import {Group} from '@pb/kit-component-group';

type Props = {
    changeRequest: ChangeRequest,
};

export const EventSource = ({changeRequest}: Props) => {
    return (
        <Group direction="v" gap="xxs" justify="space-between">
            <Group>
                <strong>Event Source:</strong>
                <EventReviewFeedback changeRequestId={changeRequest.id} fieldName={EVENT_SOURCE_FIELD_NAME}/>
            </Group>
            {changeRequest.event.source}
        </Group>
    );
};
